import { useTranslation } from 'react-i18next';
import type { ProductInformationViewModel } from 'autogen/swagger/all';
import { ButtonText } from 'autogen/translation-keys/trans-website-product-findation';
import InlineButton from 'components/generic/InlineButton';
import { GA4Tracking } from 'modules/tracking/GA4/GA4Tracking';
import useFindationQuickView from './hooks/useFindationQuickView';

export type FindationButtonProps = {
    productId: ProductInformationViewModel['productId'];
    productName: ProductInformationViewModel['name'];
};

function FindationButton(props: FindationButtonProps) {
    const { productId, productName } = props;
    const [, toggle] = useFindationQuickView();
    const { t } = useTranslation();

    return (
        <InlineButton
            onClick={() => {
                toggle({
                    isOpen: true,
                    productId: productId,
                    productName: productName
                });

                GA4Tracking({
                    eventName: 'open_modal',
                    context: 'product_page',
                    category: 'advisory',
                    eventParams: [
                        {
                            param_name: 'modal_type',
                            param_value: 'findation'
                        }
                    ]
                });
            }}
            fontWeight="semibold"
            size="M"
        >
            {t(ButtonText)}
        </InlineButton>
    );
}

export default FindationButton;
